<template>

  <BasicLayout>
    <div slot="header">Region details</div>
    <div class="name">Name: {{ region.name }}</div>
    <div class="add-box elevation-4">
      <v-toolbar flat="flat">
        <v-toolbar-title>Categories</v-toolbar-title>
      </v-toolbar>
      <v-data-table :headers="sportsColumns" hide-headers="hide-headers" hide-actions="hide-actions" :items="sports">
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="expand-icon">
              <v-icon v-if="props.expanded">mdi-chevron-down</v-icon>
              <v-icon v-else>mdi-chevron-right</v-icon>
            </td>
            <td>
              <SportLink :id="props.item.id"></SportLink>
            </td>
            <td class="add-icon">
              <v-dialog v-model="dialog" max-width="500px">
                <v-icon slot="activator">mdi-plus</v-icon>
                <v-card>
                  <v-card-title class="headline" v-if="editedIndex === -1">Add a category</v-card-title>
                  <v-card-title class="headline" v-else>Edit a category</v-card-title>
                  <v-card-text>
                    <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat="flat" @click.native="close">Cancel</v-btn>
                    <v-btn color="primary" flat="flat" @click.native="save(props.item.id)">Add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-data-table :headers="categoriesColumns" hide-headers="hide-headers" hide-actions="hide-actions" :items="categories[props.item.id] ? categories[props.item.id].categories : []">
            <template slot="items" slot-scope="props">
              <td>
                <div class="category-name">{{ props.item.name }}</div>
              </td>
              <td class="buttons">
                <v-icon class="mr-2" @click="editItem(props.item)">mdi-pencil</v-icon>
                <ProxyDeleteButton @click="deleteItem(props.item)"></ProxyDeleteButton>
              </td>
            </template>
          </v-data-table>
        </template>
      </v-data-table>
    </div>
  </BasicLayout>

</template>

<script>
import BasicLayout from '@/layouts/BasicLayout'
import EditDeleteButtons from '@/components/common/EditDeleteButtons'
import SportSelector from '@/components/SportSelector'
import SportLink from '@/components/links/Sport'
import ProxyDeleteButton from '@/components/common/ProxyDeleteButton'

export default {
  name: 'RegionDetail',
  components: {
    BasicLayout,
    EditDeleteButtons,
    SportSelector,
    SportLink,
    ProxyDeleteButton
  },
  data: () => ({
    id: null,
    categoriesArray: [],
    sportsColumns: [{
      text: '',
      width: '70px',
      sortable: false
    }, {
      text: 'Region'
    }, {
      text: 'Actions',
      sortable: false,
      width: '150px'
    }],
    categoriesColumns: [{
      text: 'Name'
    }, {
      text: 'Actions',
      width: '150px',
      sortable: false
    }],
    dialog: false,
    editedItem: {
      name: ''
    },
    editedIndex: -1
  }),
  computed: {
    region () {
      if (this.id === null) {
        return null
      }
      return this.$store.state.regions[this.id]
    },
    sports () {
      return Object.values(this.$store.state.sports)
    },
    categories () {
      const obj = {}

      for (const category of this.categoriesArray) {
        obj[category.sportID] = category
      }

      return obj
    }
  },
  methods: {
    create (id) {
      console.log('create')
      const params = {
        regionID: this.id,
        category: {
          name: this.editedItem.name,
          sportID: id
        }
      }
      this.$store.dispatch('createCateg', params)
        .then(category => {
          const find = this.categoriesArray.find(s => s.sportID === category.sportID)

          if (!find) {
            const sport = {
              sportID: category.sportID,
              categories: []
            }
            this.categoriesArray.push(sport)
          }
          find.categories.push(category)
        })
    },
    patch (id) {
      console.log('patch')
    },
    save (id) {
      if (this.editedIndex === -1) {
        this.create(id)
      } else {
        this.patch(id)
      }
      this.close()
    },
    editItem (item) {
      this.editedItem = JSON.parse(JSON.stringify(item))
      this.editedIndex = this.categories[item.sportID].indexOf(item)
      this.dialog = true
    },
    deleteItem (item) {
      this.$store.dispatch('deleteCateg', item)
      // const index = this.categoriesArray.indexOf(item)
      // console.log('deleting index ', index)
      // this.categoriesArray.splice(index, 1)
    },
    close () {
      this.dialog = !this.dialog
      this.editedIndex = -1
      this.editedItem = {
        name: ''
      }
    },
    popupAdd (sportID) {
      console.log('show add popup')
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.$store.dispatch('fetchSports')
    if (!this.$store.state.regions[this.id]) {
      this.$store.dispatch('getRegion', this.id)
        .catch(err => {
          console.log(err)
          this.$router.push('/not-found')
        })
    }
    this.$store.dispatch('fetchCategs', this.id)
      .then(categories => {
        this.categoriesArray = categories.data
      })
      .catch(err => {
        console.log(err)
        this.$router.push('/not-found')
      })
  }
}
</script>

<style lang="scss" scoped>
.categories, .add-box {
  margin-top: 20px;
}

.category-name {
  padding-left: 80px;
}

.expand-icon {
  width: 70px;
}

.add-icon {
  width: 50px;
}

.buttons {
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RegionDetail.vue